export default __webpack_public_path__ + "static/media/step1.8374a9dc.png";